module.exports = __webpack_public_path__ + "static/img/休眠.45350e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/越野车/休眠.png
// module id = JXV6
// module chunks = 76